import React, { useState } from "react";
import styles from "./DepositModal.module.scss";
import { useTranslations } from "next-intl";
import { useStore } from "@/hooks/use-store";
import getSymbolFromCurrency from "currency-symbol-map";
import { useGetPaymentSystems } from "@/domains/profile/hooks/use-get-payment-systems";
import DepositHeader from "@/domains/profile/components/deposit-header";
import DepositFooter from "@/domains/profile/components/deposit-footer";
import DepositTab from "@/domains/profile/components/deposit-tab";

export default function DepositModal() {
  const t = useTranslations("DepositModal");
  const { user } = useStore();
  const { paymentSystems } = useGetPaymentSystems();
  const [selectedType, setSelectedType] = useState<"in" | "out">("in");

  const handlerSelectedType = (_selectedType: "in" | "out") => {
    setSelectedType(_selectedType);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <DepositHeader onClick={handlerSelectedType} type={selectedType} />

        <div className={styles.flexPay}>
          <p>{t("balance")}:</p>
          <div className={styles.balanceInner}>
            <span className={styles.balanceInnerAmount}>{user.user?.balance.amount || 0}</span>
            <div className={styles.balanceCurrency}>
              <span className={styles.balanceCurrencySymbol}>
                {getSymbolFromCurrency(user.user?.balance.currency || "EUR")}
              </span>
              <span className={styles.balanceCurrencyText}>{user.user?.balance.currency || 0}</span>
            </div>
          </div>
        </div>
      </div>

      <DepositTab paymentSystems={paymentSystems[selectedType]} type={selectedType} />

      {/* <div className={styles.bonusCodeInputWrapper}>
        <div className={styles.bonusCodeInputWrapperField}>
          <input type="text" placeholder={t("bonus_code")} className={styles.bonusCodeInput} />
          <Info size={13} className={styles.infoIcon} />
        </div>
        <button className={styles.okButton}>OK</button>
      </div> */}
      {/* <button className={styles.showBonusButton}>Показать доступные бонусы</button> */}
      <DepositFooter />
    </div>
  );
}
